<template>
  <div>
    <div class="petition-counter">
      <h5>You have</h5>
      <h2>
        {{this.$store.getters.points}} points
      </h2>
    </div>
  
    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
        <div class="petition-form">
  
          <div>
              <input name="firstName" type="text" v-model="firstName" v-validate="{ required: true}" :class="{'border-red': errors.has('firstName')}" placeholder="First name">
              <input name="lastName" type="text" v-model="lastName" v-validate="{ required: true}" :class="{'border-red': errors.has('lastName')}" placeholder="Last name">
              <input name="email" type="email" v-model="email" v-validate="{ required: true, email: true}" :class="{'border-red': errors.has('email')}" placeholder="Email">
               <input name="phone" type="text" v-model="phone" placeholder="Phone">
              <input name="address" type="text" v-model="address" v-validate="{ required: true}" :class="{'border-red': errors.has('address')}" placeholder="Address">

              <select name="rewards" v-model="rewardid" v-validate="{ required: true}" :class="{'border-red': errors.has('rewards')}">
                <option value="">Select a reward</option>
                <option v-for="reward in this.$store.getters.rewards" :value="reward.code">{{reward.name}} ({{reward.points}} points)</option>
                </select>
        
            <input type="button" v-on:click="save" value="Submit" />

            <div class="privacy-statement">
              <p>By signing you accept
                <a href="/privacy-policy/privacy-policy" target="_blank">WWF-Australia&rsquo;s Privacy Policy.</a>
              </p>
            </div>

          
          </div>
  
        </div>
      </div>
  
    </div>
  
 <div v-if="!isActive" class="form-closed">
      <p>{{closingmessage}}</p>
    </div>

   </div>
</template>

<script>

import {
  getParameterByName
} from "../helpers";

export default {
  name: "loyaltyForm",
  created: function() {

    const code = getParameterByName("code");
    console.log(code)

    this.$store.dispatch("getLoyaltyDataByUniqueCode", code)
  },
  props: {
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    }
  },
  data: function () {
    return {
      points: 0,
      rewards:[],
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      rewardid:'',
      isLoading: false,
      error: false,
      isFlip: false,
      isCollapse: false,
      isShake: false    }
  },
  methods: {
    save: function() {

      this.$validator.validate().then(result => {
        if (result) {
          this.$store
                    .dispatch("saveReward", {
                      email: this.email,
                      firstname: this.firstName,
                      lastname: this.lastName,
                      phone: this.phone,
                      rewardid: this.rewardid,
                      address: this.address
                    })
                    .then(
                      response => {
                        console.log("save reward submit success", response);

                        if (window.dataLayer != undefined) {
                          window.dataLayer.push({
                            formName: "loyaltyform",
                            event: "formSubmitSuccessEvent"
                          });
                        }

                        // Reset form
                        this.firstName = "";
                        this.lastName = "";
                        this.email = "";
                        this.phone = "";
                        this.rewardid = "";
                        this.address = "";
                        this.$store.dispatch("getLoyaltyDataByUniqueCode", this.$store.getters.code)
                      },
                      error => {
                        console.error("save reward failed");
                      }
                    );

                  this.$store.commit("setPopupContent", {
                    title: this.thankyoutitle,
                    message: this.thankyoumessage,
                    shareButton: false,
                    recommendedReading: true,
                    component: null,
                    componentparams: null
                  });
                  this.$store.commit("openPetitionPopup", true);
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: "loyaltyform",
              event: "formSubmitEvent"
            });
          }
          this.isShake = true;
          setTimeout(
            function() {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// loyaltyForm.vue?30fee095